<template>
    <v-container grid-list-sm text-xs-left>
    <v-layout row wrap :class="{ 'pa-2': !isMobile() }">
        <v-flex xs12>
            <StartupList v-bind:approved="0"></StartupList>
        </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
    import {mapGetters, mapState,} from "vuex";

    import RouterService from "@/helpers/RouterService";
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import StartupList from "@/components/Lists/StartupList";


    export default {
        name: "ToBeConfirmedStartupList",
        components: {StartupList},
        data() {
            return {

            };
        },
        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
        },
    };
</script>

<style lang="scss">

</style>

